import React, { Fragment } from 'react'
import styled from 'styled-components'
import Select from 'react-select'
import arraySort from 'array-sort'
import { useSelector } from 'react-redux'
import Input from '../../typography/Input'
import InputLabel from '../../typography/Input/InputLabel'
import colors from '../../../configuration/colors'
import InputHint from '../../typography/Input/InputHint'
import IconCrossGray from '../../../static/images/icon_cross_gray.svg'
import IconCrossRed from '../../../static/images/icon_cross_red.svg'

const SkillLi = styled.li`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid ${colors.silver};
  padding: 14px 0;
`

const RemoveIcon = styled.div`
  background-image: url(${IconCrossGray});
  width: 13px;
  height: 13px;
  margin-right: 12px;
  cursor: pointer;

  &:hover {
    background-image: url(${IconCrossRed});
  }
`

const EditLinkedSkills = ({
  linkedSkills,
  setLinkedSkills
}) => {
  const frameworkSkills = useSelector(state => state.frameworkskills.items)
  const frameworkSkillGroups = useSelector(
    state => state.frameworkskills.skillGroups
  )

  const skills = linkedSkills.map(
    s => frameworkSkills.find(fs => fs.id === s.framework_skill_id)
  )
  
  const addLinkedSkill = skill => setLinkedSkills(
    ss => [
      { framework_skill_id: skill.value },
      ...ss
    ]
  )

  const removeLinkedSkill = skill => setLinkedSkills(
    ss => ss.filter(s => s.framework_skill_id !== skill.id)
  )

  const getGroupName = skill => frameworkSkillGroups.find(
    fsg => fsg.id === skill.framework_skill_group_id
  ).name

  const options = frameworkSkills
    .filter(fs => !skills.some(s => s.id === fs.id)) // exclude already selected skills
    .map(fs => {
      const groupName = getGroupName(fs)
      return {
        ...fs,
        groupName,
        value: fs.id,
        label: `${groupName}: ${fs.name}`
      }
    })
  arraySort(options, ['groupName', 'name'])

  const TargetSkillItem = ({ skill }) => (
    <SkillLi>
      <Input>
        {getGroupName(skill)}: {skill.name}
      </Input>
      <RemoveIcon onClick={() => removeLinkedSkill(skill)}/>
    </SkillLi>
  )
  
  return (
    <Fragment>
      <InputLabel>Learning Skills (Strongly Recommended)</InputLabel>
      <Select
        className="course-builder-select"
        searchable
        clearable
        options={options}
        onChange={addLinkedSkill}
        placeholder="Select targeted Learning Skill(s)."
      />
      <InputHint>
        Select targeted Learning Skill(s).  Note: Focus skills are applied in Quest! Web after enrollement.
      </InputHint>
      <ul style={{ marginTop: '5px' }}>
        {skills.map(skill => (
          <TargetSkillItem key={skill.id} skill={skill} />
        ))}
      </ul>
    </Fragment>
  )
}

export default EditLinkedSkills



// WEBPACK FOOTER //
// ./src/components/mycourses/Activities/EditLinkedSkills.js